import { render } from "./PrintMembershipCertificate.vue?vue&type=template&id=5e3d663e"
import script from "./PrintMembershipCertificate.vue?vue&type=script&lang=js"
export * from "./PrintMembershipCertificate.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__